module.exports = __webpack_public_path__ + "b0e30130c341a8d07057275e7f64195a.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lokalrunde-2.jpg
// module id = 665
// module chunks = 0